import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=158dbe89&scoped=true"
import script from "./PdfView.vue?vue&type=script&lang=js"
export * from "./PdfView.vue?vue&type=script&lang=js"
import style0 from "./PdfView.vue?vue&type=style&index=0&id=158dbe89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158dbe89",
  null
  
)

export default component.exports